import { NgModule } from '@angular/core';

import { CmsConfig, provideConfig } from '@spartacus/core';

@NgModule({
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        registerCustomerFeature: {
          cmsComponents: ['RegisterCustomerComponent'],
          module: () => import('./components/register').then((m) => m.DpRegisterModule),
        },
        loginFeature: {
          cmsComponents: ['LoginComponent'],
          module: () => import('./components/login').then((m) => m.DpLoginModule),
        },
        loginFormFeature: {
          cmsComponents: ['ReturningCustomerLoginComponent'],
          module: () => import('./components/login-form').then((m) => m.DpLoginFormModule),
        },
        loginRequestAccessFeature: {
          cmsComponents: ['RequestAccessComponent'],
          module: () => import('./components/login-request-access').then((m) => m.DpLoginRequestAccessModule),
        },
        forgotPasswordFeature: {
          cmsComponents: ['ForgotPasswordComponent'],
          module: () => import('./components/forgot-password').then((m) => m.DpForgotPasswordModule),
        },
        updatePasswordFeature: {
          cmsComponents: ['UpdatePasswordComponent'],
          module: () => import('./components/update-password').then((m) => m.DpUpdatePasswordModule),
        },
      },
    }),
  ],
})
export class DpUserAccountFeatureModule {}
